// extracted by css-extract-rspack-plugin
export default {"cls1":"ConfirmationBanner-cls1_zU_","cls2":"ConfirmationBanner-cls2_Ww4 ConfirmationBanner-cls1_zU_"};